import { addStyles } from 'ethcss'
import 'blocks.app/loader/loader.css'
import { grid, IStyles, mediaCSS } from '../../../theme'

const uploadLogNotificationStyles: IStyles = {
    wrapper: {
        width: 400,
        padding: 4,
        [mediaCSS.tab]: {
            width: 280
        }
    },
    message: {
        ...grid.mb_md
    }
}

addStyles(uploadLogNotificationStyles)
export default uploadLogNotificationStyles
